/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BlockedPeriodResponse } from './BlockedPeriodResponse';
import {
    BlockedPeriodResponseFromJSON,
    BlockedPeriodResponseFromJSONTyped,
    BlockedPeriodResponseToJSON,
    BlockedPeriodResponseToJSONTyped,
} from './BlockedPeriodResponse';
import type { DutyPreferenceResponse } from './DutyPreferenceResponse';
import {
    DutyPreferenceResponseFromJSON,
    DutyPreferenceResponseFromJSONTyped,
    DutyPreferenceResponseToJSON,
    DutyPreferenceResponseToJSONTyped,
} from './DutyPreferenceResponse';

/**
 * 
 * @export
 * @interface CounselorDutyPreferencesResponse
 */
export interface CounselorDutyPreferencesResponse {
    /**
     * 
     * @type {string}
     * @memberof CounselorDutyPreferencesResponse
     */
    counselorId: string;
    /**
     * 
     * @type {number}
     * @memberof CounselorDutyPreferencesResponse
     */
    courtHours: number | null;
    /**
     * 
     * @type {number}
     * @memberof CounselorDutyPreferencesResponse
     */
    awHours: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CounselorDutyPreferencesResponse
     */
    preferredCourtIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CounselorDutyPreferencesResponse
     */
    excludedCourtIds: Array<string>;
    /**
     * 
     * @type {Array<DutyPreferenceResponse>}
     * @memberof CounselorDutyPreferencesResponse
     */
    dutyPreferences: Array<DutyPreferenceResponse>;
    /**
     * 
     * @type {Array<BlockedPeriodResponse>}
     * @memberof CounselorDutyPreferencesResponse
     */
    blockedPeriods: Array<BlockedPeriodResponse>;
}

/**
 * Check if a given object implements the CounselorDutyPreferencesResponse interface.
 */
export function instanceOfCounselorDutyPreferencesResponse(value: object): value is CounselorDutyPreferencesResponse {
    if (!('counselorId' in value) || value['counselorId'] === undefined) return false;
    if (!('courtHours' in value) || value['courtHours'] === undefined) return false;
    if (!('awHours' in value) || value['awHours'] === undefined) return false;
    if (!('preferredCourtIds' in value) || value['preferredCourtIds'] === undefined) return false;
    if (!('excludedCourtIds' in value) || value['excludedCourtIds'] === undefined) return false;
    if (!('dutyPreferences' in value) || value['dutyPreferences'] === undefined) return false;
    if (!('blockedPeriods' in value) || value['blockedPeriods'] === undefined) return false;
    return true;
}

export function CounselorDutyPreferencesResponseFromJSON(json: any): CounselorDutyPreferencesResponse {
    return CounselorDutyPreferencesResponseFromJSONTyped(json, false);
}

export function CounselorDutyPreferencesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CounselorDutyPreferencesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'counselorId': json['counselorId'],
        'courtHours': json['courtHours'],
        'awHours': json['awHours'],
        'preferredCourtIds': json['preferredCourtIds'],
        'excludedCourtIds': json['excludedCourtIds'],
        'dutyPreferences': ((json['dutyPreferences'] as Array<any>).map(DutyPreferenceResponseFromJSON)),
        'blockedPeriods': ((json['blockedPeriods'] as Array<any>).map(BlockedPeriodResponseFromJSON)),
    };
}

export function CounselorDutyPreferencesResponseToJSON(json: any): CounselorDutyPreferencesResponse {
    return CounselorDutyPreferencesResponseToJSONTyped(json, false);
}

export function CounselorDutyPreferencesResponseToJSONTyped(value?: CounselorDutyPreferencesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'counselorId': value['counselorId'],
        'courtHours': value['courtHours'],
        'awHours': value['awHours'],
        'preferredCourtIds': value['preferredCourtIds'],
        'excludedCourtIds': value['excludedCourtIds'],
        'dutyPreferences': ((value['dutyPreferences'] as Array<any>).map(DutyPreferenceResponseToJSON)),
        'blockedPeriods': ((value['blockedPeriods'] as Array<any>).map(BlockedPeriodResponseToJSON)),
    };
}

